import { Alert, Box, Text } from '@chakra-ui/react'
import { useOnlineStatus } from '../../hooks/useOnlineStatus'

export default function NetworkStatusBanner() {
  const { isOnline } = useOnlineStatus()
  if (isOnline) return null

  return (
    <Box position="sticky" top={0} zIndex={1400}>
      <Alert.Root status="error" borderRadius="0">
        <Alert.Indicator />
        <Alert.Content>
          <Alert.Description>You're offline. We'll retry once you're back online.</Alert.Description>
        </Alert.Content>
      </Alert.Root>
    </Box>
  )
}

